<h3 class="greeting accent">{{'MSG.GREETING' | translate}}</h3>
<small class="login-title accent">{{'MSG.RSYPWD' | translate}}</small>
<form (ngSubmit)="onSubmit()" [formGroup]="resetForm" class="flex-col reset-form">
    <label class="lt label-control" for="new-password">{{'LABEL.NEW_PASSWORD' | translate | titlecase}}</label>
    <mat-form-field color="accent" appearance="outline">
        <input
            formControlName="password"
            id="new-password"
            name="new-password"
            [attr.autocomplete]="'new-password'"
            type="password"
            matInput
            required
            [placeholder]="'LABEL.NEW_PASSWORD' | translate | titlecase">
        <mat-icon svgIcon="password" matPrefix></mat-icon>
    </mat-form-field>
    <mat-error @fade *ngIf="password.hasError('required') && password.touched">
        {{ 'MSG.PASSWORD_REQUIRED' | translate }}
    </mat-error>
    <mat-error @fade *ngIf="password.hasError('pattern')">
        {{ 'MSG.PASSWORD_MUST_MATCH_PATTERN' | translate }}
    </mat-error>

    <label class="lt label-control" for="confirmPassword">{{'LABEL.CONFIRM_NEW_PASSWORD' | translate | titlecase}}</label>
    <mat-form-field color="accent" appearance="outline">
        <input
            id="confirmPassword"
            type="password"
            autocomplete="off"
            matInput
            required
            formControlName="confirmPassword"
            [placeholder]="'LABEL.CONFIRM_NEW_PASSWORD' | translate | titlecase">
            <mat-icon svgIcon="password" matPrefix></mat-icon>
    </mat-form-field>
    <mat-error @fade *ngIf="confirmPassword.hasError('required') && confirmPassword.touched">
        {{ 'MSG.CONFIRM_PASSWORD_REQUIRED' | translate }}
    </mat-error>
    <mat-error @fade *ngIf="confirmPassword.hasError('pattern')">
        {{ 'MSG.PASSWORD_MUST_MATCH_PATTERN' | translate }}
    </mat-error>

    <mat-error @fade *ngIf="confirmPassword.touched && resetForm.hasError('notSame')">{{ 'MSG.PASSWORD_NOT_SAME' | translate }}</mat-error>
    <mat-error @fade *ngIf="confirmPassword.touched && resetForm.hasError('token')">{{ 'MSG.TOKEN_ERROR' | translate }}</mat-error>
    <div class="flex-row between set">
        <!-- <mat-checkbox class="text-light" disableRipple>{{'LABEL.REMEMBER_ME' | translate}}</mat-checkbox> -->
        <a class="accent" routerLink="/auth/login">{{'LABEL.LOGIN' | translate}}</a>
    </div>
    <button
        color="accent"
        mat-flat-button
        type="submit"
        class="submit">
        {{'LABEL.RESET_PASSWORD' | translate}}
    </button>
</form>
<div class="alert">
    <p class="lt">{{'MSG.DONT_HAVE_ACC' | translate}} <a class="accent" routerLink="/auth/register">{{'LABEL.REGISTER_HERE' | translate}}</a></p>
</div>
    <!-- <div class="app-available">
        <img alt="playstore" src="/assets/img/playstore.png">
        <img alt="appstore" src="/assets/img/appstore.png">
    </div> -->
<!-- </div> -->
